import { useAppContext } from "@/context/AppContext";
import { Fragment, useEffect, useRef, useState } from "react";

import HCaptcha from "@hcaptcha/react-hcaptcha";
import { Turnstile } from "@marsidev/react-turnstile";
import { Skeleton } from "./ui/skeleton";

export const useCaptcha = () => {
  const [load, setLoad] = useState(false);
  const { captchaVendor } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef<any>(undefined);
  const [componentKey, setComponentKey] = useState("---");

  const reset = () => {
    setComponentKey(new Date().getTime() / 1000 + "");
  };

  useEffect(() => {
    setIsLoading(false);
    setComponentKey(new Date().getTime() / 1000 + "");
    setLoad(true);
  }, []);

  return {
    load,
    setLoad,
    captchaVendor,
    reset,
    ref,
    componentKey,
    isLoading,
    setIsLoading,
  };
};

export type CaptchaComponentProp = ReturnType<typeof useCaptcha>;

export const CaptchaComponent = ({
  prop: { load, captchaVendor, componentKey, isLoading },
  onSuccess,
  action = "",
}: {
  prop: CaptchaComponentProp;
  onSuccess(token: string): void;
  action?: string;
}) => {
  const [vendor, setVendor] = useState("");
  const { locale } = useAppContext();

  useEffect(() => {
    if (
      captchaVendor === "RANDOM" ||
      captchaVendor === "UNKNOWN" ||
      !captchaVendor
    ) {
      const captchas = ["TURNSTILE", "HCAPTCHA"];
      //@ts-ignore
      setVendor(captchas[Math.floor(Math.random() * captchas.length)]);
    } else {
      setVendor(captchaVendor);
    }
  }, [captchaVendor]);

  if (!load) {
    return <Fragment />;
  }

  if (isLoading) {
    return <Skeleton className="w-full h-32" />;
  }

  if (vendor === "TURNSTILE") {
    return (
      <Turnstile
        key={componentKey}
        siteKey={
          process.env.NEXT_PUBLIC_TURNSTILE || "1x00000000000000000000AA"
        }
        options={{
          theme: "light",
          action,
        }}
        onSuccess={(token) => onSuccess(token)}
      />
    );
  }

  if (vendor === "HCAPTCHA") {
    return (
      <HCaptcha
        key={componentKey}
        sitekey={process.env.NEXT_PUBLIC_HCAPTCHA}
        languageOverride={locale === "id" ? "id" : "en"}
        onVerify={(token, ekey) => onSuccess(`hcaptcha:${token}|${ekey}`)}
      />
    );
  }

  return <div className="p-3">Captcha not available for a moment</div>;
};
